<template>
  <div>
    <div>
      <div v-for="(item, index) in visits.data" :key="'register-visit' + index">
        <validation-observer
          ref="registerVisitForm"
          novalidate
          tag="form"
          @submit.prevent="handleSaveVisit"
        >
          <custom-callout
            class="mb-3 custom-callout"
            :controlled="true"
            :opened="item.isOpen"
            @click:open="onToggleAdditionalInfo(item, index)"
          >
            <div class="row">
              <div class="col-md-1 col-sm-12 col-spacing hour-size">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Día:
                </div>
                <validation-provider
                  v-if="!item.saved"
                  v-slot="{ errors }"
                  name="Día"
                  rules="required"
                >
                  <custom-input
                    v-model="item.day"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
                <span v-else class="color-black">{{ item.day }}</span>
              </div>
              <div class="col-md-3 col-sm-12 col-spacing">
                <div
                  v-if="!item.saved"
                  class="color-secondary-6 font-weight-normal font-14"
                >
                  Hora Desde:
                </div>
                <div
                  v-else
                  class="color-secondary-6 font-weight-normal font-14"
                >
                  Hora:
                </div>
                <div v-if="!item.saved" class="d-flex">
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartHour"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourStartHour"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartMinute"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourStartMinute"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="item.hourStartTime"
                    class="ampm-size"
                    :options="timeOptions"
                  />
                </div>
                <div v-else>
                  <span class="color-black">
                    {{ getHourRange(item) }}
                  </span>
                </div>
              </div>
              <div v-if="!item.saved" class="col-md-3 col-sm-12 col-spacing">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Hora Hasta:
                </div>
                <div v-if="!item.saved" class="d-flex">
                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEnd"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourEnd"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEndMinute"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourEndMinute"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="item.hourEndTime"
                    class="ampm-size"
                    :options="timeOptions"
                  />
                </div>
              </div>
              <div class="col-md-3 col-spacing">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Tipo:
                </div>
                <span v-if="!item.saved">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="SelectedType"
                    rules="required"
                  >
                    <CustomDropDown
                      v-model="item.selectedType"
                      :disabled="item.id"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="visitTypes"
                      @input="handleChangeVisitType"
                    />
                  </ValidationProvider>
                  <div
                    v-if="
                      item.selectedType && item.selectedType.showPreviousYears
                    "
                    class="mt-2"
                  >
                    <span class="color-secondary-6 font-weight-normal font-14">
                      Año Anterior:
                    </span>
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <CustomDropDown
                        v-model="item.previousAcademicYear"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="description"
                        :options="compensatoryYears"
                        @input="handleChangeCompensatoryYear(item)"
                      />
                    </ValidationProvider>
                  </div>
                  <div
                    v-if="
                      item.selectedType &&
                        item.previousAcademicYear &&
                        item.previousAcademicYear.id > 0
                    "
                    class="mt-2"
                  >
                    <span class="color-secondary-6 font-weight-normal font-14">
                      Solicitud:
                    </span>
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <CustomDropDown
                        v-model="item.compensatoryRequestSelected"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        :options="filteredCompensatoryNumbers"
                      />
                    </ValidationProvider>
                  </div>
                </span>
                <span v-else class="color-black">
                  {{ getItemName(item.selectedType) }}
                </span>
              </div>
              <div
                v-if="!isPeriodFinalized"
                class="col-md-1 justify-content-end align-items-center pt-4"
                :class="{
                  'col-md-3': item.saved,
                  'pr-5': !item.saved,
                }"
              >
                <div
                  v-if="enableActionMenu(item) && !item.enableReplaceSpecialist"
                  class="dropdown"
                >
                  <button
                    id="dropdownMenuButton"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                    data-toggle="dropdown"
                    type="button"
                  >
                    Acciones
                  </button>
                  <div
                    aria-labelledby="dropdownMenuButton"
                    class="dropdown-menu dropdown-menu-right custom-dropdown-container"
                  >
                    <div
                      class="dropdown-item cursor-pointer mb-1"
                      @click="editVisit(item, index)"
                    >
                      <em class="fa fa-pencil text-green pr-1" />
                      <span>Editar Visita</span>
                    </div>
                    <div
                      class="dropdown-item cursor-pointer"
                      @click="onDeleteVisit(item.id, index)"
                    >
                      <em class="fa fa-times-circle text-red pr-1" />
                      <span>Eliminar Visita</span>
                    </div>
                    <hr class="mt-2" />
                    <div
                      class="dropdown-item cursor-pointer mt-n2"
                      @click="replaceServicePlace(item, index)"
                    >
                      <em class="fa fa-exchange text-green pr-1" />
                      <span>Reemplazar Maestro y/o Asistente de Servicios</span>
                    </div>
                  </div>
                </div>
                <div v-if="enableActionButton(item)" class="mt-n3">
                  <action-button
                    v-if="
                      (!item.saved && item.id) || item.enableReplaceSpecialist
                    "
                    class="px-4 mt-4"
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger"
                    @click="onCancelEdit(item, index)"
                  >
                    Cancelar
                  </action-button>
                  <action-button
                    class="px-4 mt-4"
                    i="fas fa-save"
                    text="Guardar"
                    variant="success"
                    @click="handleSaveVisit(item, item.id, index)"
                  />
                </div>
              </div>
              <div class="col-12 mt-n2">
                <visit-tag
                  v-if="item.hasOverrideTeacherSpecialist"
                  color="green"
                  icon="fas fa-user-md"
                  label="Reemplazo de Maestro"
                  type="green"
                />
                <visit-tag
                  v-if="item.hasOverrideAssistanceServiceSpecialist"
                  color="orange"
                  icon="fas fa-user-md"
                  label="Reemplazo de Asistente de Servicio"
                  type="red"
                />
              </div>
            </div>
            <template #edition class="p-3 pb-2 custom-callout-edition">
              <div class="bg-secondary-9 p-2">
                <div class="info-panel bg-white rounded pb-3">
                  <b-tabs
                    active-nav-item-class="mipe-tab font-weight-bold text-green active-nav-item-custom"
                    active-tab-class=""
                    content-class="mt-3"
                    nav-class="custom-nav-container"
                    :no-nav-style="true"
                  >
                    <b-tab
                      :active="
                        item.selectedTab ==
                          additionalInfoTabs.REPLACE_SPECIALIST
                      "
                      title="Reemplazar Maestro / Asistente de Servicios"
                    >
                      <div class="row mx-3">
                        <div class="col-md-6">
                          <checkbox
                            v-model="item.selectedTeacherSpecialistOption"
                            class="mb-2"
                            :disabled="
                              item.saved && !item.isReplaceSpecialistVisible
                            "
                            text="Maestro:"
                            @input="
                              onChangeSelectedTeacherSpecialist(
                                item.selectedTeacherSpecialistOption,
                                item,
                                index
                              )
                            "
                          />
                          <custom-drop-down
                            v-model="item.selectedTeacherSpecialist"
                            :disabled="
                              (item.saved &&
                                !item.isReplaceSpecialistVisible) ||
                                !item.selectedTeacherSpecialistOption
                            "
                            fieldkey="id"
                            fieldname="name"
                            :options="teacherSpecialists"
                            placeholder="Seleccione"
                          />
                        </div>

                        <div class="col-md-6">
                          <checkbox
                            v-model="
                              item.selectedAssistanceServiceSpecialistOption
                            "
                            class="mb-2"
                            :disabled="
                              item.saved && !item.isReplaceSpecialistVisible
                            "
                            text="Asistente de Servicio:"
                            @input="
                              onChangeSelectedAssistanceServiceSpecialist(
                                item.selectedAssistanceServiceSpecialistOption,
                                item
                              )
                            "
                          />
                          <custom-drop-down
                            v-model="item.selectedAssistanceServiceSpecialist"
                            :disabled="
                              (item.saved &&
                                !item.isReplaceSpecialistVisible) ||
                                !item.selectedAssistanceServiceSpecialistOption
                            "
                            fieldkey="id"
                            fieldname="name"
                            :options="assistanceServiceSpecialists"
                            placeholder="Seleccione"
                          />
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </template>
          </custom-callout>
          <div
            v-if="item.errors || item.validations"
            class="visit-error-container"
          >
            <error
              v-for="(error, errorIndex) in item.validations"
              :key="`validation-container-visit` + errorIndex"
              :message="error"
              variant="no-border"
            />
            <error
              v-for="(error, errorIndex) in item.errors"
              :key="`error-container-visit` + errorIndex"
              :message="error"
              variant="no-border"
            />
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
//third party libs
import _ from 'lodash';
import moment from 'moment';
import { serialize as objectToFormData } from 'object-to-formdata';
import 'moment/locale/es-do';

//common libs
import Error from 'custom-error';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import Checkbox from 'CheckBox';

import VisitTag from './VisitTag';
import visitTypes from '@/utils/constants/visitTypes.js';

//vuex reference
import {
  ACTION_TYPES,
  MUTATION_TYPES,
} from '@/modules/visitRegistry/store/types';
import { name } from '@/modules/visitRegistry/store';
import { createNamespacedHelpers } from 'vuex';
const {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} = createNamespacedHelpers(name);

//service
import visitRegistryApi from '@/modules/visitRegistry/api.js';

//mixins
import alertMixin from '@/mixins/alert.mixin.js';

//constants
import locationTypes from '@/utils/constants/locationTypes.js';
import tapRequestSpecialistSpecialtyTypes from '@/utils/constants/tapRequestSpecialistSpecialtyTypes.js';

export default {
  name: 'RegisterEducationVisit',
  components: {
    CustomCallout,
    CustomInput,
    CustomDropDown,
    ActionButton,
    Error,
    Checkbox,
    VisitTag,
  },
  mixins: [alertMixin],
  props: {
    referralForVisits: {
      type: Array,
      default: () => [],
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
    isPeriodFinalized: {
      type: Boolean,
      default: () => false,
    },
    compensatoryInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    visitAdmissionIds: [],
    visits: {
      data: [
        {}, // set entry mode
      ],
    },
    teacherSpecialists: [],
    assistanceServiceSpecialists: [],
    visitLocations: [],
    visitLocationServices: [],
    visitMunicipalities: [],
    visitRegions: [],
    visitDistricts: [],
    visitSchools: [],
    visitCenters: [],
    editVisitOriginalInfo: {},
    compensatoryYears: [],
    compensatoryNumbers: [],
    filteredCompensatoryNumbers: [],
  }),
  computed: {
    ...mapGetters({
      selectedPeriodFiltered: 'getFilteredPeriod',
    }),
    ...mapState({
      visitTypes: (state) => state.catalog.visitTypes,
    }),
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    selectedPeriod() {
      return this.$route.params.initialPeriodInfo
        ? this.$route.params.currentPeriod
        : this.selectedPeriodFiltered;
    },
    additionalInfoTabs() {
      return {
        ASSISTANCE_SERVICE: 1,
        REPLACE_SPECIALIST: 2,
      };
    },
    getHourRange() {
      return (item) => {
        return (
          moment(
            `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
            'hh:mm A'
          )
            .format('h:mm A')
            .toLowerCase() +
          ' - ' +
          moment(
            `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`,
            'hh:mm A'
          )
            .format('h:mm A')
            .toLowerCase()
        );
      };
    },
    enableActionButton() {
      return (item) =>
        (!item.saved && !this.isPeriodFinalized) ||
        item.enableReplaceSpecialist;
    },
    enableActionMenu() {
      return (item) => item.saved || item.enableReplaceSpecialist;
    },
    enableReplaceSpecialist() {
      return (item) => (item.enableReplaceSpecialist ? true : false);
    },
    assistanceServiceSpecialistsAvailable() {
      return (item) => {
        return _.differenceBy(
          this.assistanceServiceSpecialists,
          item.assistanceServiceSpecialistsSelected,
          'id'
        );
      };
    },
    getItemName() {
      return (item) => {
        return item?.id ? item.visitTypeName : '';
      };
    },
    visitAcademicYearId() {
      return this.studentInfo.academicYearId;
    },
    visitCompanyId() {
      return this.studentInfo.companyId;
    },
  },
  watch: {
    referralForVisits: {
      handler(newValue) {
        if (newValue) {
          this.getVisitList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions([ACTION_TYPES.DELETE_VISIT]),
    ...mapMutations([MUTATION_TYPES.SET_CLEAR_CATALOG]),
    async onChangePlaceType(item, index) {
      this.updateVisitEntry(index, {
        selectedRegion: null,
        selectedDistrict: null,
        selectedSchool: null,
        selectedMunicipality: null,
        selectedCenter: null,
        selectedLocationService: null,
      });
      if (item?.selectedPlaceType?.id) {
        if (item?.selectedPlaceType?.id == locationTypes.Escuela) {
          await this.callGetVisitRegion();
        }
        if (
          [
            locationTypes.CSEE,
            locationTypes.OfficinaProveedor,
            locationTypes.CAAT,
            locationTypes.Hogar,
          ].includes(item?.selectedPlaceType?.id)
        ) {
          await this.callGetMunicipality(item);
        }
      }

      //clear descendants values
      this.clearCatalogValues({
        visitLocationServices: [],
        visitDistricts: [],
        visitSchools: [],
      });
    },
    async handleChangeCompensatoryYear(item) {
      const previousAcademicYearIdSelected = item?.previousAcademicYear?.id;

      if (previousAcademicYearIdSelected > 0) {
        this.filteredCompensatoryNumbers = this.compensatoryNumbers.filter(
          (x) => x.academicYearId == previousAcademicYearIdSelected
        );
        if (
          this.filteredCompensatoryNumbers.findIndex(
            (x) => x.id === item?.compensatoryRequestSelected?.id
          ) === -1
        ) {
          item.compensatoryRequestSelected = null;
        }
      } else {
        this.filteredCompensatoryNumbers = [];
        item.compensatoryRequestSelected = null;
      }
    },
    async handleChangeVisitType(value) {
      if (value?.id) {
        await this.getAcademicYearsAndCompensatoryNumbers();
      }
    },
    async getAcademicYearsAndCompensatoryNumbers() {
      const response = await visitRegistryApi.getAcademicYearsAndCompensatoryNumbers(
        this.studentInfo.studentSieId,
        126
      );
      if (response?.data) {
        this.compensatoryYears = response.data.years;
        this.compensatoryNumbers = response.data.compensatories;
      }
    },
    isHourEndOverLimit(item) {
      const from = moment(
        `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
        'hh:mm A'
      );
      const to = moment(
        `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`,
        'hh:mm A'
      );
      const isFrom7a = from.isSameOrAfter(moment('7:00 AM', 'hh:mm A'));
      const isAfter8p = to.isSameOrBefore(moment('8:00 PM', 'hh:mm A'));
      let isOnTimeSlot = isFrom7a && isAfter8p ? true : false;
      return isOnTimeSlot;
    },

    isAfterValidityDate(day) {
      const assigmentStartDateEn = moment(this.studentInfo.assignmentStartDate)
        .locale('en-US')
        .format('DD/MMM/YYYY');

      const visitDateEn = moment(this.getVisitDate(day))
        .locale('en-US')
        .format('DD/MMM/YYYY');

      return Date.parse(assigmentStartDateEn) <= Date.parse(visitDateEn);
    },

    onToggleAdditionalInfo(item, itemIndex) {
      this.visits = {
        ...this.visits,
        data: this.visits.data.map((s, index) => {
          if (index === itemIndex) {
            s.isOpen = !s.isOpen;
          } else {
            s.isOpen = false;
          }
          return s;
        }),
      };
    },
    async onChangeSelectedAssistanceServiceSpecialist(value, item) {
      if (!value) {
        item.selectedAssistanceServiceSpecialist = null;
        await this.$forceUpdate();
      }
    },
    async onChangeSelectedTeacherSpecialist(value, item) {
      if (!value) {
        item.selectedTeacherSpecialist = null;
        await this.$forceUpdate();
      }
    },
    onChangeSelectedPlace(item, index) {
      if (item.selectedPlaceOption == false) {
        this.updateVisitEntry(index, {
          selectedMunicipality: null,
          selectedCenter: null,
          selectedLocationService: null,
          selectedSchool: null,
          selectedDistrict: null,
          selectedRegion: null,
          selectedPlaceType: null,
        });
      }
    },
    onCancelEdit(item, itemIndex) {
      if (item?.id) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = true;
              s.isOpen = false;
              s.enableReplaceSpecialist = false;
              s.isReplaceSpecialistVisible = false;
              s.selectedPlaceOption = false;
              s.selectAssistanceService = null;
              s.day = this.editVisitOriginalInfo.day;
              s.hourStartHour = this.editVisitOriginalInfo.hourStartHour;
              s.hourStartMinute = this.editVisitOriginalInfo.hourStartMinute;
              s.hourStartTime = this.editVisitOriginalInfo.hourStartTime;
              s.hourEnd = this.editVisitOriginalInfo.hourEnd;
              s.hourEndMinute = this.editVisitOriginalInfo.hourEndMinute;
              s.hourEndTime = this.editVisitOriginalInfo.hourEndTime;
            } else {
              s.isOpen = false;
            }
            return s;
          }),
        };
      }
    },
    async handleSaveVisit(item, saveEdit, index) {
      const isValid = await this.$refs.registerVisitForm[index].validate();
      const _validations = this.validateVisitEntry(item, index);

      if (isValid && _validations.length === 0) {
        this.updateVisitEntry(index, { validations: null });

        //El slice se usa para quitar el timezone del user.
        const visitDate = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
        ])
          .format()
          .slice(0, -6);

        const timeStartFull = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
          this.parseHour(item.hourStartTime, item.hourStartHour),
          item.hourStartMinute,
        ])
          .format()
          .slice(0, -6);

        const timeEndFull = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
          this.parseHour(item.hourEndTime, item.hourEnd),
          item.hourEndMinute,
        ])
          .format()
          .slice(0, -6);

        const periodDate = new Date(
          this.selectedPeriodFiltered.year,
          this.selectedPeriodFiltered.monthNumber - 1,
          1
        );

        const dataToSend = {
          visitId: item.id ?? null,
          requestId: this.studentInfo.id,
          studentSieId: this.studentInfo.studentSieId,
          timeStart: timeStartFull,
          timeEnd: timeEndFull,
          date: visitDate,
          academicYearId: this.studentInfo.academicYearId,
          filteredPeriodDate: periodDate,
          visitTypeId: item.selectedType?.id ?? null,
          durationId: this.studentInfo.durationId ?? null,
          modalityId: this.studentInfo.modalityId ?? null,
          locationTypeId: item.id
            ? item.selectedPlaceType?.id ?? null
            : this.studentInfo?.locationTypeId,
          centerId:
            this.studentInfo.filter?.center?.id || this.studentInfo.centerId,
          companyId: this.studentInfo.companyId,
          comment: item.visitInfoComment,
          teacherSpecialistId: item.selectedTeacherSpecialist?.id,
          assistanceServiceSpecialistId:
            item.selectedAssistanceServiceSpecialist?.id,
          assistanceServices: item.assistanceServiceSpecialistsSelected,
          previousAcademicYearId: item.previousAcademicYear?.id,
          compensatoryRequestIdSelected: item.compensatoryRequestSelected?.id,
        };

        //set current locationYearId
        let locationFiscalYearId = null;
        if (item.selectedPlaceType?.id == locationTypes.CSEE) {
          locationFiscalYearId = item.selectedCenter?.id ?? null;
        }
        if (item.selectedPlaceType?.id == locationTypes.Escuela) {
          locationFiscalYearId = item.selectedSchool?.id ?? null;
        }
        if (
          [locationTypes.OfficinaProveedor, locationTypes.CAAT].includes(
            item.selectedPlaceType?.id
          )
        ) {
          locationFiscalYearId = item.selectedLocationService?.id ?? null;
        }
        if (item.selectedPlaceType?.id == locationTypes.Hogar) {
          locationFiscalYearId = item.selectedMunicipality?.id ?? null;
        }

        //set current locationFiscalYearId
        dataToSend.locationFiscalYearId = locationFiscalYearId;

        let formData = objectToFormData(dataToSend, {
          indices: true,
          nullsAsUndefineds: true,
        });

        await visitRegistryApi
          .saveEducationVisit(formData)
          .then(() => {
            this.ShowToast(
              'Proceso exitoso.',
              'Sus datos han sido guardados exitosamente.',
              'success'
            );
            this.getVisitList();
            this.updateVisitEntry(index, { isOpen: false });
            this.$emit('reloadVisitTypes');
          })
          .catch((r) => {
            this.ShowToast('Alerta', r.response.data.message, 'error');
          });
      } else {
        this.updateVisitEntry(index, { validations: _validations });
      }
    },
    getPeriodDate() {
      return moment()
        .year(this.selectedPeriod.year)
        .month(this.selectedPeriod.monthNumber - 1)
        .date(1)
        .toDate();
    },
    async getVisitList() {
      const { data: response } = await visitRegistryApi.getEducationVisits(
        this.studentInfo.id,
        parseInt(this.selectedPeriod.monthNumber)
      );
      if (response) {
        const result = response.map((x) => {
          const startHour = moment(x.visitTimeStart, 'HH:mm:ss').hours();
          const startMinute = moment(x.visitTimeStart, 'HH:mm:ss').minutes();

          const hourStartFormat = moment().set({
            hour: startHour,
            minute: startMinute,
          });

          const endHour = moment(x.visitTimeEnd, 'HH:mm:ss').hours();
          const endMinute = moment(x.visitTimeEnd, 'HH:mm:ss').minutes();

          const hourEndFormat = moment().set({
            hour: endHour,
            minute: endMinute,
          });

          x.hourStartHour = hourStartFormat.format('h');
          x.hourStartTime = hourStartFormat.format('A').toLowerCase();

          x.hourEnd = hourEndFormat.format('h').toLowerCase();
          x.hourEndMinute = hourEndFormat.format('m').toLowerCase();
          x.hourEndTime = hourEndFormat.format('A').toLowerCase();

          x.saved = true;

          //document
          x.documentType = x.documentType?.id ? x.documentType : null;

          //override teacher
          x.selectedTeacherSpecialistOption = x.teacherSpecialist != null;
          x.selectedTeacherSpecialist = x.teacherSpecialist?.id
            ? x.teacherSpecialist
            : null;

          //override assistance service
          x.selectedAssistanceServiceSpecialistOption =
            x.assistanceServiceSpecialist != null;
          x.selectedAssistanceServiceSpecialist = x.assistanceServiceSpecialist
            ?.id
            ? x.assistanceServiceSpecialist
            : null;

          //location type
          x.selectedPlaceOption = x.selectedPlaceType?.id ? true : false;
          x.selectedPlaceType = x.selectedPlaceType?.id
            ? x.selectedPlaceType
            : null;
          x.selectedRegion = x.selectedRegion?.id ? x.selectedRegion : null;
          x.selectedDistrict = x.selectedDistrict?.id
            ? x.selectedDistrict
            : null;
          x.selectedMunicipality = x.selectedMunicipality?.id
            ? x.selectedMunicipality
            : null;
          x.selectedCenter = x.selectedCenter?.id ? x.selectedCenter : null;
          x.selectedSchool = x.selectedSchool?.id ? x.selectedSchool : null;
          x.selectedLocationService = x.selectedLocationService?.id
            ? x.selectedLocationService
            : null;
          x.assistanceServiceSpecialistsSelected = x.assistanceServices;
          if (
            x.previousAcademicYear &&
            x.previousAcademicYear.name !== undefined
          ) {
            x.previousAcademicYear.description = x.previousAcademicYear.name;
            delete x.previousAcademicYear.name;
          }

          return x;
        });

        this.visits = {
          data: this.isPeriodFinalized ? [...result] : [...result, {}],
        };
      }
    },
    async callGetVisitLocationTypes() {
      this.visitLocations = await visitRegistryApi.getLocationsType();
    },
    async callGetVisitRegion() {
      this.visitRegions = (
        await visitRegistryApi.getVisitRegion(
          this.visitAcademicYearId,
          this.visitCompanyId
        )
      ).data;
    },
    async callGetVisitDistrict(regionId) {
      this.visitDistricts = (
        await visitRegistryApi.getVisitDistrict(
          this.visitAcademicYearId,
          regionId,
          this.visitCompanyId
        )
      ).data;
    },
    async callGetVisitSchool(regionId, districtId) {
      this.visitSchools = (
        await visitRegistryApi.getVisitSchool(
          this.visitAcademicYearId,
          regionId,
          districtId,
          this.visitCompanyId
        )
      ).data;
    },
    async callGetMunicipality(item) {
      this.visitMunicipalities = (
        await visitRegistryApi.getVisitMunicipalities(
          this.visitAcademicYearId,
          item.selectedPlaceType?.id,
          this.visitCompanyId
        )
      ).data;
    },
    async callGetCenter(municipalityId) {
      this.visitCenters = (
        await visitRegistryApi.getVisitCenters(
          this.visitAcademicYearId,
          municipalityId,
          this.visitCompanyId
        )
      ).data;
    },
    async callGetLocationServices(item) {
      let locTypeId = [locationTypes.CAAT].includes(item.selectedPlaceType?.id)
        ? locationTypes.CAAT
        : item.selectedPlaceType?.id;

      this.visitLocationServices = (
        await visitRegistryApi.getVisitLocationServices(
          this.visitAcademicYearId,
          locTypeId,
          item?.selectedMunicipality?.id,
          this.visitCompanyId
        )
      ).data;
    },
    onChangeAssistanceServiceHandler(item, itemIndex) {
      if (item.selectedAssistanceSpecialist?.id) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              if (!Array.isArray(s.assistanceServiceSpecialistsSelected)) {
                s.assistanceServiceSpecialistsSelected = [];
              }
              s.assistanceServiceSpecialistsSelected = [
                ...s.assistanceServiceSpecialistsSelected,
                item.selectedAssistanceSpecialist,
              ];
              s.selectedAssistanceSpecialist = null;
            }
            return s;
          }),
        };
      }
    },
    clearCatalogValues(values) {
      this[MUTATION_TYPES.SET_CLEAR_CATALOG](values);
    },
    onChangeDocument(selectedDocument, itemIndex) {
      if (selectedDocument) {
        this.updateVisitEntry(itemIndex, {
          isDocumentRemoved: null,
        });
      }
    },
    unSelectItem(item) {
      if (item) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s) => {
            if (s.isOpen) {
              s.assistanceServiceSpecialistsSelected = s.assistanceServiceSpecialistsSelected.filter(
                (pItem) => {
                  return pItem.id != item.id;
                }
              );
            }
            return s;
          }),
        };
      }
    },
    unSelectAssistanceServiceItem(item) {
      if (item) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s) => {
            if (s.isOpen) {
              s.assistanceServiceSpecialistsSelected = s.assistanceServiceSpecialistsSelected.filter(
                (pItem) => {
                  return pItem.id != item.id;
                }
              );
            }
            return s;
          }),
        };
      }
    },
    async editVisit(item, itemIndex) {
      if (item?.id) {
        await this.getAcademicYearsAndCompensatoryNumbers();
        this.editVisitOriginalInfo = { ...item };
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = false;
            } else {
              if (s.id) {
                s.saved = true;
                s.isOpen = false;
                s.enableReplaceSpecialist = false;
                s.isReplaceSpecialistVisible = false;
              }
            }
            return s;
          }),
        };
      }
    },
    async onDeleteVisit(id) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar la visita documentada?',
        'Sí',
        'No'
      );
      if (answer) {
        this.ShowToast(
          'Proceso Exitoso',
          'La información fue actualizada exitosamente.',
          'success'
        );
        await visitRegistryApi.deleteEducationVisit(id);
        this.getVisitList();
        this.$emit('reloadVisitTypes');
      }
    },
    async replaceServicePlace(item, index) {
      this.editVisitOriginalInfo = { ...item };
      await this.getTeacherSpecialists();
      await this.getAssistanceServiceSpecialists();
      await this.callGetVisitLocationTypes();

      //call descendants
      if (
        [
          locationTypes.OfficinaProveedor,
          locationTypes.CAAT,
          locationTypes.Hogar,
        ].includes(item.selectedPlaceType?.id)
      ) {
        await this.callGetMunicipality(item);
      }
      if (item.selectedPlaceType?.id == locationTypes.Escuela) {
        await this.callGetVisitRegion();
      }

      //do toggle
      this.visits = {
        ...this.visits,
        data: this.visits.data.map((mItem, mIndex) => {
          if (mIndex == index) {
            mItem.isOpen = true;
            mItem.enableReplaceSpecialist = true;
            mItem.selectedTab = this.additionalInfoTabs.REPLACE_SPECIALIST;
            mItem.isReplaceSpecialistVisible = true;
          } else {
            if (mItem.id) {
              mItem.saved = true;
              mItem.isOpen = false;
              mItem.enableReplaceSpecialist = false;
              mItem.isReplaceSpecialistVisible = false;
            }
          }
          return mItem;
        }),
      };
    },
    validateVisitEntry(item) {
      const validations = [];
      const _hourIsValid = this.isHourValid(item);
      const _isValidHourEnd = item.hourEnd
        ? this.isValidHourEnd(
            `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
            `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`
          )
        : true;

      if (
        !this.periodValidation(item.day) &&
        item.selectedType.id != visitTypes.Visita_Educativa_Reposicion
      ) {
        validations.push(
          'No se identificó vigencia de servicio para el día de visita.'
        );
      }

      const validForFuture = [
        visitTypes.Servicio_Presencial,
        visitTypes.Servicio_Virtual,
      ].includes(item.selectedType?.id);

      const _visitDayIsFuture = validForFuture
        ? this.visitDayIsFuture(item.day)
        : false;

      const _hourEndOverLimit = this.isHourEndOverLimit(item);
      const _visitIsAfterValidityDate = this.isAfterValidityDate(item.day);

      if (!item.day) {
        validations.push('Favor de entrar el día de la visita.');
      }
      if (!item.hourStartHour || !item.hourStartMinute || !item.hourStartTime) {
        validations.push('Favor de entrar la hora de comienzo de la visita.');
      }
      if (!item.selectedType?.id) {
        validations.push('Favor de seleccionar el tipo de visita.');
      }
      if (
        item.selectedType &&
        item.selectedType.id === visitTypes.Visita_Educativa_Reposicion &&
        !item.previousAcademicYear?.id
      ) {
        validations.push('Favor de seleccionar el año académico anterior.');
      }
      if (
        item.selectedType &&
        item.selectedType.id === visitTypes.Visita_Educativa_Reposicion &&
        item.previousAcademicYear?.id &&
        !item.compensatoryRequestSelected?.id
      ) {
        validations.push('Favor de seleccionar la solicitud.');
      }

      if (
        item.selectedType &&
        item.selectedType.id === visitTypes.Visita_Educativa_Reposicion &&
        item.previousAcademicYear?.id &&
        item.compensatoryRequestSelected?.id &&
        (moment(this.getVisitDate(item.day)).day() === 6 ||
          moment(this.getVisitDate(item.day)).day() === 0)
      ) {
        validations.push('No puede registrar visitas fines de semana.');
      }
      if (!item.hourEnd || !item.hourEndMinute || !item.hourEndTime) {
        validations.push('Favor de entrar la hora de fin de la visita.');
      }
      if (!_hourIsValid) {
        validations.push('La hora no es válida');
      }
      if (!_isValidHourEnd) {
        validations.push('La hora hasta debe ser mayor a la hora desde.');
      }
      if (_visitDayIsFuture) {
        validations.push('El día de la visita no puede ser al futuro.');
      }
      if (!_hourEndOverLimit) {
        validations.push(
          'El horario de la visita sobrepasa el límite permitido (7:00am a 8:00pm).'
        );
      }
      if (!_visitIsAfterValidityDate) {
        validations.push(
          'No se identificó vigencia de servicio para el día de visita.'
        );
      }
      return validations;
    },
    visitDayIsFuture(day) {
      let visitDate = this.getVisitDate(day);
      let currentDate = new Date();
      return visitDate > currentDate;
    },
    getVisitDate(visitday) {
      if (!visitday) {
        return null;
      }

      return new Date(
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        parseInt(visitday)
      );
    },
    updateVisitEntry(entryIndex, prop) {
      if (prop) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((item, index) => {
            if (entryIndex === index) {
              item = {
                ...item,
                ...prop,
              };
            }
            return item;
          }),
        };
      }
    },
    async getAssistanceServiceSpecialists() {
      this.assistanceServiceSpecialists = (
        await visitRegistryApi.getSpecialistBySpecialtyType(
          this.visitAcademicYearId,
          this.visitCompanyId,
          tapRequestSpecialistSpecialtyTypes.AsistenteDeServicio
        )
      ).data;
    },
    async getTeacherSpecialists() {
      this.teacherSpecialists = (
        await visitRegistryApi.getSpecialistBySpecialtyType(
          this.visitAcademicYearId,
          this.visitCompanyId,
          tapRequestSpecialistSpecialtyTypes.ServicioEducativo
        )
      ).data;
    },
    isHourValid(item) {
      const _values = this.getEntryValues(item);

      const hour = parseInt(_values.hour, 10);
      const min = _values.min;
      const ampm = _values.ampm;

      const visitHour = moment(`${hour}:${min} ${ampm}`, 'h:mm A', true);

      return visitHour.isValid();
    },
    getEntryValues(item) {
      return {
        hour: item.hourStartHour,
        min: item.hourStartMinute,
        ampm: item.hourStartTime,
      };
    },
    isValidHourEnd(startHour, endHour) {
      const from = moment(startHour, 'hh:mm A');
      const to = moment(endHour, 'hh:mm A');
      return to.isAfter(from) && !to.isSame(from);
    },
    parseHour(time, hour) {
      if (hour == 12) {
        return parseInt(hour);
      }
      return time.toLowerCase() == 'pm' ? parseInt(hour) + 12 : hour;
    },
    periodValidation(day) {
      if (this.referralForVisits.length == 0) {
        return null;
      }

      return this.referralForVisits.some((r) =>
        moment(this.getVisitDate(day)).isBetween(
          moment(r.assignmentStartDate),
          moment(r.assignmentEndDate),
          'days',
          '[]'
        )
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 86px;
  .toggle-icon {
    flex: 1;
    cursor: pointer;
    text-align: center;
    em {
      margin-top: 12px;
      font-size: 26px;
    }
  }
  .separator-line {
    background: transparent linear-gradient(270deg, #f7f7f700 0%, #efefef 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 10px;
    height: 100%;
  }
}
.orange-color {
  color: #ff7058;
}
.green-color {
  color: #2db782;
}
.hour-size {
  width: 60px;
  margin-right: 10px;
}
.ampm-size {
  width: 80px;
  margin-right: 10px;
}

/* overrides */
.custom-callout {
  .col-spacing {
    padding: 20px 15px;
  }
  ::v-deep .callout-container {
    padding: 0px !important;
    border-left-width: 0px;
  }
  ::v-deep .collaut-edition {
    margin-top: 3px !important;
    padding: 7px !important;
  }
}

::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  .nav-item {
    .nav-link {
      color: map-get($colors, 'secondary-6');
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

.custom-dropdown-container {
  max-width: 250px;
  min-width: 250px;
  .dropdown-item {
    white-space: unset;
    padding: 0.25rem 1rem;
    em {
      margin-right: 10px;
    }
  }
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
</style>
